import {
  CHANGE_PASSWORD,
  CHANGE_PROFILE,
  STRIPE_PAYMENT,
  UPLOAD_MEDIA,
  UPLOAD_MEDIA_SELLER,
  USER_DASHBOARD,
  USER_INFO,
  USER_NOTIFICATIONS_LIST,
} from "../constants/paths";
import { axios } from "./axios";

/**
 * get user info
 * @date 17/07/2023 - 12:48:51
 *
 * @returns {*}
 */
export const getUserDetails = () => {
  return axios.get(USER_INFO);
};

/**
 * change Profile
 * @date 17/07/2023 - 12:48:42
 *
 * @param {*} data
 * @returns {*}
 */
export const changeProfile = (data) => {
  const config = { headers: { "content-type": "multipart/form-data" } };
  return axios.put(CHANGE_PROFILE, data, config);
};
/**
 * Description placeholder
 * @date 24/07/2023 - 18:16:44
 *
 * @param {*} data
 * @returns {*}
 */
export const uploadMedia = (data) => {
  const config = { headers: { "content-type": "multipart/form-data" } };
  return axios.post(UPLOAD_MEDIA, data, config);
};
export const uploadMediaSeller = (data) => {
  const config = { headers: { "content-type": "multipart/form-data" } };
  return axios.post(UPLOAD_MEDIA_SELLER, data, config);
};

export const changePassword = (data) => {
  return axios.put(CHANGE_PASSWORD, data);
};

export const getStripePayment = (data) => {
  return axios.post(STRIPE_PAYMENT, data);
};
export const getUserDashboard = (params) => {
  return axios.get(`${USER_DASHBOARD}`, { params });
};
export const getNotificationList = (params) => {
  return axios.get(`${USER_NOTIFICATIONS_LIST}`, { params });
};
